/**
 *
 * Asynchronously loads the component for Apa001
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
